<template>

  <base-dialog :show="!!error" title="An error ocurred" @close="handleError">
    <p>{{error }}</p>
  </base-dialog>
  <section>
    <skipper-filter @change-filter="setFilters"></skipper-filter>
  </section>
  <section>
    <base-card> 
      <div class="controls">
        <base-button mode="outline" @click="loadSkippers(true)">Refresh</base-button>
        <base-button link to="/auth?redirect=register" v-if="!isLoggedIn">Login to Register as Skipper</base-button>
        <base-button v-if="isLoggedIn && !isSkipper && !isLoading" link to="/register">Register as Skipper</base-button>
      </div>
      <div v-if="isLoading">
      <base-spinner></base-spinner>
      </div>
      <ul v-else-if="hasSkippers">
        <skipper-item
          v-for="skipper in filteredSkippers"
          :key="skipper.id"
          :id="skipper.id"
          :firstName="skipper.firstName"
          :lastName="skipper.lastName"
          :age="skipper.age"
          :achievements="skipper.achievements"
        ></skipper-item>
      </ul>
      <h3 v-else>No Skippers found.</h3>
    </base-card>
  </section>
</template>



<script>
import SkipperItem from '../../components/skippers/SkippersItem.vue';
import SkipperFilter from '../../components/skippers/SkipperFilter.vue';
import BaseDialog from '../../components/ui/BaseDialog.vue';


export default {
  components: { SkipperItem,SkipperFilter,BaseDialog },

  data() {

    return {
      isLoading: false,
      error: null,

      activeFilters: {
          vendee_arctique: true,
          transat_jacques_vabre:true,
          rolex_fastnet_race:true,
          route_de_rhum:true,
          bermudes_1000_race:true
      }
    }
  },

  computed: {

    isLoggedIn() {
      return this.$store.getters.isAuthenticated;

    },
    filteredSkippers() {
      const skippers = this.$store.getters.skippers;
      return skippers.filter(skipper => {
        if(this.activeFilters.vendee_arctique && skipper.achievements.includes('Vendée Arctique')) {
          return true;  
          
        }
        if(this.activeFilters.transat_jacques_vabre && skipper.achievements.includes('Transat Jacques Vabre')) {
          return true;  

        }
        if(this.activeFilters.rolex_fastnet_race && (skipper.achievements.includes('Rolex Fastnet Race') || skipper.achievements.includes('Fastnet Race'))) {
          return true;  

        }
        if(this.activeFilters.route_de_rhum && skipper.achievements.includes('Route de Rhum')) {
          return true;  
        }
        if(this.activeFilters.bermudes_1000_race && skipper.achievements.includes('Bermudes 1000 Race')) {
          return true;  
        }
             
        else {
          return false;
        }        
      });

    },
    hasSkippers() {
      return !this.isLoading && this.$store.getters.hasSkippers;
      
      
    },
    isSkipper() {
        return this.$store.getters.isSkipper;
        
      }, 
   
  },
  created() {
   this.loadSkippers();
   

  },

  methods: {

    setFilters(updatedFilters) {
      this.activeFilters = updatedFilters;
    },
    loadSkippers(refresh = false) {
      this.isLoading = true;
      this.$store.dispatch('loadSkippers',{forceRefresh : refresh}).then(()=> {

         this.isLoading = false;
         
      }).catch(error => {
        this.error = error.message || 'Something went wrong.'
    });  
    },
    handleError() {

      this.error = null;
    }
  },


};

</script>

<style>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.controls {
  display: flex;
  justify-content: space-between;
}
</style>
